export const convertToUTC = (date: string) => {
  return new Date(date).toISOString();
};
